import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Значок с подписью в строке: «опубликована» у версии анкеты.
 *
 * Не чип. Чипов в той строке уже два — номер версии и её статус, — и третий
 * превращал заголовок в ряд коробок. В макете это именно значок с подписью,
 * прижатый к правому краю.
 */
export function Mark({ icon, children }: { icon: ReactNode; children: ReactNode }) {
  return (
    <span className={styles.mark}>
      {icon}
      {children}
    </span>
  );
}
